<aa-staff-app-layout>
  <router-outlet></router-outlet>
</aa-staff-app-layout>
